export default __webpack_public_path__ + "static/media/mt5_ios.bf09d83d.png";